import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '@/components/ui/table';
import Pagination from '@components/Pagination';
import Spinner from '@components/Spinner';
import NoResults from './NoResults';

const ClassroomsTable = ({
  classrooms,
  isLoading,
  pagesCount,
  page,
  setPage,
}) => {
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (rowId) => {
    setExpandedRows(prev => ({ ...prev, [rowId]: !prev[rowId] }));
  };

  if (isLoading) return <Spinner />;
  if (!classrooms || classrooms.length === 0) return <NoResults />;

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12 px-2 py-3 text-center" /> {/* For expand icon */}
            <TableHead className="w-[45%] px-4 py-3">Name</TableHead> {/* Adjusted width */}
            <TableHead className="w-[15%] px-4 py-3">Archived</TableHead> {/* Adjusted width */}
            <TableHead className="w-[15%] px-4 py-3">Students</TableHead> {/* Adjusted width */}
            <TableHead className="w-[25%] px-4 py-3">Pending Invitations</TableHead> {/* Adjusted width */}
          </TableRow>
        </TableHeader>
        <TableBody>
          <For each='classroom' of={classrooms}>
            <>
              <TableRow key={classroom.id}>
                <TableCell className="w-12 px-2 py-3 text-center align-middle">
                  <If condition={classroom.seriesAssignments?.nodes?.length > 0}>
                    <button onClick={() => toggleRow(`classroom-${classroom.id}`)} >
                      {expandedRows[`classroom-${classroom.id}`] ? <ChevronDown className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
                    </button>
                  </If>
                </TableCell>
                <TableCell className="w-[45%] px-4 py-3 align-middle">
                  {classroom.name}
                </TableCell>
                <TableCell className="w-[15%] px-4 py-3 align-middle">
                  {classroom.archived ? 'Yes' : 'No'}
                </TableCell>
                <TableCell className="w-[15%] px-4 py-3 align-middle">
                  {classroom.studentsCount}
                </TableCell>
                <TableCell className="w-[25%] px-4 py-3 align-middle">
                  {classroom.pendingInvitationsCount}
                </TableCell>
              </TableRow>

              <If condition={expandedRows[`classroom-${classroom.id}`] && classroom.seriesAssignments?.nodes?.length > 0}>
                <TableRow key={`${classroom.id}-series-wrapper`} className="border-none">
                  <TableCell colSpan={5} className="p-0"> {/* Adjusted colSpan */}
                    <Table className="shadow-none rounded-none border-collapse w-full">
                      <TableHeader>
                        <TableRow className="border-t border-b">
                          <TableHead className="w-12 px-2 py-3 text-center align-middle border-none" />
                          <TableHead className="flex-1 px-4 py-3 align-middle border-none">Pathway</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        <For each='seriesAssignment' of={classroom.seriesAssignments.nodes}>
                          <>
                            <TableRow key={seriesAssignment.series.id} className="border-b">
                              <TableCell className="w-12 px-2 py-3 text-center align-middle border-none">
                                <If condition={seriesAssignment.series.educatorProjects?.length > 0}>
                                  <button onClick={() => toggleRow(`series-${seriesAssignment.series.id}`)} >
                                    {expandedRows[`series-${seriesAssignment.series.id}`] ? <ChevronDown className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
                                  </button>
                                </If>
                              </TableCell>
                              <TableCell className="flex-1 px-4 py-3 align-middle border-none">{seriesAssignment.series.name}</TableCell>
                            </TableRow>
                            <If condition={expandedRows[`series-${seriesAssignment.series.id}`] && seriesAssignment.series.educatorProjects?.length > 0}>
                              <TableRow key={`${seriesAssignment.series.id}-projects-wrapper`} className="border-none">
                                <TableCell colSpan={2} className="p-0"> {/* Adjusted colSpan */}
                                  <Table className="shadow-none rounded-none border-collapse w-full">
                                    <TableHeader>
                                      <TableRow className="border-t border-b">
                                        <TableHead className="flex-1 px-4 py-3 align-middle border-none pl-16">Lesson</TableHead>
                                      </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                      <For each='project' of={seriesAssignment.series.educatorProjects}>
                                        <TableRow key={project.id} className="border-t">
                                          <TableCell className="flex-1 px-4 py-3 align-middle border-none pl-16">{project.name}</TableCell>
                                        </TableRow>
                                      </For>
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>
                            </If>
                          </>
                        </For>
                      </TableBody>
                    </Table>
                  </TableCell>
                </TableRow>
              </If>
            </>
          </For>
        </TableBody>
      </Table>
      <Pagination page={page} pagesCount={pagesCount} setPage={setPage} />
    </>
  );
};

export default ClassroomsTable;
